import { render, staticRenderFns } from "./UpdateNotification.vue?vue&type=template&id=17d233bc&"
import script from "./UpdateNotification.vue?vue&type=script&lang=js&"
export * from "./UpdateNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports